module.exports = __webpack_public_path__ + "static/img/specialist.7fb3401.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/specialist.jpg
// module id = 300
// module chunks = 1